module.exports = __webpack_public_path__ + "img/DE00592.7aae298e.png";